/** Normalize CMS image fields that may be a legacy URL string or `{ src, alt }`. */
export function asImageAsset(value) {
  if (typeof value === "string") {
    return { src: value, alt: "" };
  }
  if (value && typeof value === "object") {
    return {
      src: typeof value.src === "string" ? value.src : "",
      alt: typeof value.alt === "string" ? value.alt : "",
    };
  }
  return { src: "", alt: "" };
}

export function normalizeHomeSectionIcons(home) {
  if (!home) return home;

  return {
    ...home,
    features: home.features
      ? {
          ...home.features,
          sectionIcon: asImageAsset(home.features.sectionIcon),
        }
      : home.features,
    howItWorks: home.howItWorks
      ? {
          ...home.howItWorks,
          sectionIcon: asImageAsset(home.howItWorks.sectionIcon),
        }
      : home.howItWorks,
    roleExperience: home.roleExperience
      ? {
          ...home.roleExperience,
          sectionIcon: asImageAsset(home.roleExperience.sectionIcon),
        }
      : home.roleExperience,
  };
}

export function normalizeSolutionsSectionIcons(solutions) {
  if (!solutions) return solutions;

  return {
    ...solutions,
    smartSolutions: solutions.smartSolutions
      ? {
          ...solutions.smartSolutions,
          sectionIcon: asImageAsset(solutions.smartSolutions.sectionIcon),
        }
      : solutions.smartSolutions,
    integratedDevices: solutions.integratedDevices
      ? {
          ...solutions.integratedDevices,
          sectionIcon: asImageAsset(solutions.integratedDevices.sectionIcon),
        }
      : solutions.integratedDevices,
  };
}
